/*
Defines the custom element <ravel-crossfade-background>
*/

import { RavelCrossfadeBackground } from './src/RavelCrossfadeBackground.js';

customElements.define('ravel-crossfade-background', RavelCrossfadeBackground);
